import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./resendActivationScreen.css";
import {
  HOME_URL,
  PUBLIC_URL_PREFIX,
  UBER_ADMIN_SETTINGS_URL,
  AxiosConfigNoAuth,
} from "../../Utils/Constants";
import t from "../../Utils/Translation";
import lykio_logo from "../../multimedia/Default/white_loading.gif";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const DownloadPage = () => {
  const [authScreensLogo, setAuthScreensLogo] = useState();
  const [windowsDownloadLink, setWindowsDownloadLink] = useState("#");
  const [macDownloadLink, setMacDownloadLink] = useState("#");
  const [androidDownloadLink, setAndroidDownloadLink] = useState("#");
  const [iosDownloadLink, setIosDownloadLink] = useState("#");

  useEffect(() => {
    async function fetchUberData() {
      const { data } = await axios.get(
        `${PUBLIC_URL_PREFIX}${UBER_ADMIN_SETTINGS_URL}`,
        AxiosConfigNoAuth()
      );
      data.uberSettings &&
        setAuthScreensLogo(data.uberSettings.authScreensLogo);
      data.uberSettings &&
        setWindowsDownloadLink(data.uberSettings.windowsDownloadLink);
      data.uberSettings &&
        setMacDownloadLink(data.uberSettings.macDownloadLink);
      data.uberSettings &&
        setAndroidDownloadLink(data.uberSettings.androidDownloadLink);
      data.uberSettings &&
        setIosDownloadLink("https://testflight.apple.com/join/QE8Z0WjO");
    }
    fetchUberData();
  }, []);

  return (
    <div className="lykiocss-generic-background lykiocss-forms-container">
      <div className="lykiocss-screen-center">
        <div className="LykioForm lykiocss-white-background lykiocss-form-border lykiocss-form-size">
          <Link to={HOME_URL}>
            <div className="lykiocss-center">
              <img
                className="lykiocss-small-login-logo"
                src={authScreensLogo ? authScreensLogo : lykio_logo}
                alt=""
              />
            </div>
          </Link>
          <h3 className="resendactivation-screen__title">
            {t("Choose your version")}
          </h3>
          {windowsDownloadLink.length > 1 && (
            <Form.Group className="mb-3" controlId="email">
              <Button
                href={windowsDownloadLink}
                download
                variant="primary"
                type="submit"
                className="lykiocss-center"
                size="sm"
              >
                <i class="bi bi-microsoft"></i> {t("Download for Windows")}
              </Button>
            </Form.Group>
          )}
          {macDownloadLink.length > 1 && (
            <Form.Group className="mb-3" controlId="email">
              <Button
                href={macDownloadLink}
                download
                variant="primary"
                type="submit"
                className="lykiocss-center"
                size="sm"
              >
                <i class="bi bi-command"></i> {t("Download for Mac ")}
              </Button>
            </Form.Group>
          )}
          {androidDownloadLink.length > 1 && (
            <Form.Group className="mb-3" controlId="email">
              <Button
                href={androidDownloadLink}
                download
                variant="primary"
                type="submit"
                className="lykiocss-center"
                size="sm"
              >
                <i class="bi bi-phone"></i> {t("Download for Android")}
              </Button>
              <p className="text-muted mt-3 mb-2" 
              style={{textAlign:'center', fontSize: '14px', fontWeight:'400'}}>
              How to install the app on your Android device</p>
              <small className="text-muted lykiocss-instructions-container">
              <ol>
                  <li>Tap the above button: This will directly open the app's page on the Google Play Store.</li>
                  <li>Tap the "Install" button: Once on the app's Play Store page, you'll see an "Install" button. Tap on it to begin the download and installation process.</li>
                  <li>Wait for the download: The app will begin downloading. You'll see a progress bar indicating the download status. It may take a few seconds to a few minutes, depending on your internet connection.</li>
                  <li>Automatic installation: After the download completes, the Play Store will automatically begin the installation process. You don't need to do anything during this step.</li>
                  <li>Open the app: Once installation is complete, the "Install" button will change to an "Open" button on the Play Store page. Tap on it to launch the app immediately.</li>
                  <li>Locate the app on your device: You can also find the newly installed app in your device's app drawer or home screen. Tap on its icon to launch it anytime.</li>
              </ol>
            </small>
            </Form.Group>
          )}
          {iosDownloadLink.length > 1 && (
            <Form.Group className="mb-3" controlId="email">
              <Button
                href={iosDownloadLink}
                download
                variant="primary"
                type="submit"
                className="lykiocss-center"
                size="sm"
              >
                <i class="bi bi-apple"></i> {t("Download for iOS")}
              </Button>
              <p className="text-muted mt-3 mb-2" 
              style={{textAlign:'center', fontSize: '14px', fontWeight:'400'}}>
              How to install the app on your iOS device</p>
              <small className="text-muted lykiocss-instructions-container">
              <ol>
                <li>To install an app with TestFlight on your iOS device, first ensure you have the TestFlight app installed from the App Store.</li>
                <li>Then, simply open the TestFlight invitation link found on the button above, and follow the on-screen instructions to download and install the app.</li>
              </ol>
            </small>
            </Form.Group>
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadPage;
